// services/products.js
import axiosInstance from './axiosInstance';

const PRODUCTS_API_URL = '/products';

const productsService = {
  async get(idempresa, familia = '') {
    try {
      const familiaParam = familia ? `&familia=${familia}` : '';
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/get.php?idempresa=${idempresa}${familiaParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter produtos:', error);
      return [];
    }
  },

  async getWithFilter(idempresa, filters = {}) {
    try {
      const { familia, mov_stock, combustivel, where } = filters;
      let url = `${PRODUCTS_API_URL}/get.php?idempresa=${idempresa}`;
      
      if (familia) url += `&familia=${familia}`;
      if (mov_stock) url += `&mov_stock=true`;
      if (combustivel) url += `&combustivel=true`;
      if (where) url += `&where=${encodeURIComponent(where)}`;
      
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter produtos com filtro:', error);
      return [];
    }
  },

  async getPriceById(idempresa, idproduct, idprovider = null) {
    try {
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/price/getById.php?idempresa=${idempresa}&idproduct=${idproduct}&idprovider=${idprovider}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async bulkGetPriceById(idempresa, idproducts) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/price/bulkGetById.php`, {
        idempresa: idempresa,
        idproducts: idproducts
      });
      return response.data?.success ? response.data.data : {};
    } catch (error) {
      console.error('Erro ao obter preços em bulk:', error);
      return {};
    }
  },

  async getById(idempresa, idproduct, idcustomer = null) {
    try {
      const customerParam = idcustomer ? `&idcustomer=${idcustomer}` : '';
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/getById.php?idempresa=${idempresa}&idproduct=${idproduct}${customerParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter produto por ID:', error);
      return [];
    }
  },

  async getByBarcode(idempresa, barcode) {
    try {
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/getByBarcode.php?idempresa=${idempresa}&barcode=${barcode}`);
      return response.data !== "NOK" ? response.data : null;
    } catch (error) {
      console.error('Erro ao obter produto por código de barras:', error);
      return null;
    }
  },

  async set(payload) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/set.php`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar produto:', error);
      throw error;
    }
  },

  async unset(idempresa, idproduct) {
    try {
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/unset.php?idempresa=${idempresa}&idproduct=${idproduct}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover produto:', error);
      throw error;
    }
  },

  async import(formData) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/import.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao importar produtos:', error);
      throw error;
    }
  },

  async export(idempresa) {
    try {
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/export.php?idempresa=${idempresa}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao exportar produtos:', error);
      throw error;
    }
  },

  // Stocks
  async setStocks(payload) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/stocks/set.php`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar stocks:', error);
      throw error;
    }
  },

  // Prices
  async setPrices(payload) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/price/set.php`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar preços:', error);
      throw error;
    }
  },

  // Composition
  async getCompositionById(idempresa, idproduct) {
    try {
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/composition/getById.php?idempresa=${idempresa}&idproduct=${idproduct}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter composição:', error);
      return [];
    }
  },

  async setComposition(payload) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/composition/set.php`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar composição:', error);
      throw error;
    }
  },

  async unsetComposition(idempresa, idproduct, idproduct2) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/composition/unset.php`, {
        idempresa,
        idproduct,
        idproduct2
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao remover composição:', error);
      throw error;
    }
  },

  // Barcodes
  async setBarcode(payload) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/barcodes/set.php`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar código de barras:', error);
      throw error;
    }
  },

  async unsetBarcode(payload) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/barcodes/unset.php`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover código de barras:', error);
      throw error;
    }
  },

  // Providers
  async setProviders(payload) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/providers/set.php`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar fornecedores:', error);
      throw error;
    }
  },

  // Transactions
  async getTransactionsById(idempresa, idproduct, doctypes = [], page = 1, pageSize = 10) {
    try {
      const doctypesParam = doctypes.map(type => `doctypes[]=${type}`).join('&');
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/transactions/getById.php?idempresa=${idempresa}&idproduct=${idproduct}&${doctypesParam}&page=${page}&pageSize=${pageSize}`);
      return response.data !== "NOK" ? response.data : { entries: [], totalPages: 0 };
    } catch (error) {
      console.error('Erro ao obter transações:', error);
      return { entries: [], totalPages: 0 };
    }
  },

  async getTransactionsByWarehouse(idempresa, idposto, idproduct, doctypes = [], page = 1, pageSize = 10) {
    try {
      const doctypesParam = doctypes.map(type => `doctypes[]=${type}`).join('&');
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/transactions/warehouses/getById.php?idempresa=${idempresa}&idposto=${idposto}&idproduct=${idproduct}&${doctypesParam}&page=${page}&pageSize=${pageSize}`);
      return response.data !== "NOK" ? response.data : { entries: [], totalPages: 0 };
    } catch (error) {
      console.error('Erro ao obter transações do armazém:', error);
      return { entries: [], totalPages: 0 };
    }
  },

  // Additional methods for other endpoints
  async getPostoProducts(idempresa, warehouseid) {
    try {
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/posto/getAll.php?idempresa=${idempresa}&idposto=${warehouseid}`);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter produtos do posto:', error);
      return {};
    }
  },

  async getPostoProductsByFamilia(idempresa, familia, warehouseid) {
    try {
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/posto/getAll.php?familia=${familia}&idempresa=${idempresa}&idposto=${warehouseid}`);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter produtos do posto por família:', error);
      return {};
    }
  },

  async getPostoProductsByFilter(idempresa, combustivel = false, where = '') {
    try {
      const whereParam = where ? `&where=${encodeURIComponent(where)}` : '';
      const combustivelParam = combustivel ? '&combustivel=true' : '';
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/posto/get.php?idempresa=${idempresa}${combustivelParam}${whereParam}`);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter produtos do posto com filtro:', error);
      return {};
    }
  },

  async bulkSetProviderCodes(idempresa, idprovider, combinations) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/providers/codes/bulkSet.php`, {
        idempresa: idempresa,
        idprovider: idprovider,
        combinations: combinations
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao criar códigos de fornecedor em bulk:', error);
      throw error;
    }
  },

  // Photos
  async setPhoto(formData) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/setPhotos.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar foto do produto:', error);
      throw error;
    }
  },

  async unsetPhoto(idempresa, idproduct) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/unsetPhotos.php`, {
        idempresa: idempresa,
        idproduct: idproduct
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao remover foto do produto:', error);
      throw error;
    }
  },

  async fetchImageProxy(imageUrl) {
    try {
      const response = await axiosInstance.get(`/products/images/fetch_proxy.php?url=${encodeURIComponent(imageUrl)}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar imagem via proxy:', error);
      throw error;
    }
  },

  // History
  async getHistory(idempresa, idproduct, search = '', page = 1, limit = 10) {
    try {
      const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
      const response = await axiosInstance.get(`/products/history/get.php?idempresa=${idempresa}&idproduct=${idproduct}&page=${page}&limit=${limit}${searchParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter histórico:', error);
      return [];
    }
  },

  // Change Product Code (Admin only)
  async changeProductCode(idempresa, oldIdproduct, newIdproduct) {
    try {
      const response = await axiosInstance.post(`${PRODUCTS_API_URL}/changeProductCode.php`, {
        idempresa: idempresa,
        oldIdproduct: oldIdproduct,
        newIdproduct: newIdproduct
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao alterar código do produto:', error);
      throw error;
    }
  },

  // Invalid Products
  async getInvalid(idempresa) {
    try {
      const response = await axiosInstance.get(`${PRODUCTS_API_URL}/invalid.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter produtos inválidos:', error);
      return [];
    }
  }
};

export default productsService;
